import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getPlatformAPI } from '../lib/platform'

/**
 * Hält Reiter-Titel und Beschreibung in der Sprache der Oberfläche.
 *
 * Nur im Web: Electron hat keinen Reiter, und der Fenstertitel kommt vom
 * Main-Prozess.
 *
 * Für **Link-Vorschauen** taugt das nicht — Slack, WhatsApp und Suchmaschinen
 * führen kein JavaScript aus und lesen das ausgelieferte HTML. Dafür gibt es
 * die zweite Einstiegsseite aus `vite/webHeadTags.ts` und die Weiche in
 * `vercel.json` (`.claude/tasks/web-favicon-und-metadaten.md`).
 */
export function useDocumentTitle(): void {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    if (getPlatformAPI().platform !== 'web') return

    document.title = t('meta.title')

    const description = document.querySelector<HTMLMetaElement>('meta[name="description"]')
    if (description) description.content = t('meta.description')

    document.documentElement.lang = i18n.language.startsWith('de') ? 'de' : 'en'
  }, [t, i18n.language])
}
